"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var supportMerits_1 = require("../supportMerits");
var supportMeritsConfig = {
    wherewego: {
        supportMerits: supportMerits_1.wwgSupportMerits,
        suportMeritsOptions: supportMerits_1.wwgSupportMeritOptions,
        supportMeritsIconsMapping: supportMerits_1.wwgSupportMeritIconsMapping,
    },
    skillup: {
        supportMerits: supportMerits_1.skillUpSupportMerits,
        suportMeritsOptions: supportMerits_1.skillUpSupportMeritsOptions,
        supportMeritsIconsMapping: supportMerits_1.skillUpSupportMeritsIconMapping,
    },
};
exports.default = supportMeritsConfig;
